import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import apiAxios from '/src/config/request.js';
import baseFunc from '/src/config/base_func.js';
import 'ant-design-vue/dist/antd.less';


const app = createApp(App);
app.config.globalProperties.$apiRequest = apiAxios;
app.config.globalProperties.$baseFunc = baseFunc;  
app.use(Antd).mount('#app');
